import { Widget } from "blue-widgets";

class Tabs extends Widget {
  constructor(el) {
    super(el);
    this.tabContainer = this.el.querySelector(":scope > [data-tabs]");
    this.tabs = Array.from(
      this.tabContainer.querySelectorAll(":scope > [data-tab]")
    );
    this.content = this.el.querySelectorAll(":scope > [data-content]");
    this.customSelect = this.el.querySelector(
      ":scope > [data-widget='CustomSelect']"
    );
    if (this.customSelect) {
      this.mobileTabsContainer = this.customSelect.querySelector(
        ":scope > [data-tabs-mobile-container]"
      );
      this.mobileSelect = this.mobileTabsContainer.querySelector(
        ":scope > select[data-tabs-mobile]"
      );
    }

    this.handleClick = this.handleClick.bind(this);
    this.setActive = this.setActive.bind(this);
    this.removeActive = this.removeActive.bind(this);
    this.initMobileTabs = this.initMobileTabs.bind(this);
    this.handleMobileClick = this.handleMobileClick.bind(this);
    this.setAttributes = this.setAttributes.bind(this);

    this.init();

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => this.handleClick(tab));
    });
  }

  init() {
    // Set first tab and content as active
    this.tabs[0].classList.add("active");
    this.content[0].classList.add("active");

    this.setAttributes(this.tabs);

    // Init mobile tabs if they exist
    if (this.mobileTabsContainer) this.initMobileTabs();
  }

  initMobileTabs() {
    // Add event listener to mobile select input
    this.mobileSelect.addEventListener("change", () => {
      this.handleMobileClick(this.mobileSelect.value);
    });

    this.mobileOptions = Array.from(this.mobileSelect.options);

    // Set attributes for mobile tabs
    this.setAttributes(this.mobileOptions);
  }

  handleMobileClick(option) {
    const tabIndex = this.mobileOptions.findIndex(
      (tab) => tab.value === option
    );

    this.removeActive({ isMobile: true });
    this.setActive(tabIndex, { isMobile: true });
  }

  setAttributes(tabs) {
    // Add aria labels
    tabs.forEach((tab, index) => {
      if (index === 0) {
        tab.setAttribute("aria-selected", "true");
        tab.setAttribute("tabindex", "0");
      } else {
        tab.setAttribute("aria-selected", "false");
        tab.setAttribute("tabindex", "-1");
      }
    });
  }

  handleClick(tab) {
    if (tab.classList.contains("active")) return;
    this.removeActive();
    this.setActive(tab);
  }

  setActive(tab, isMobile) {
    let tabIndex;
    if (isMobile) {
      tabIndex = tab;
      this.mobileSelect.options[tabIndex].setAttribute("aria-selected", "true");
    } else {
      tabIndex = this.tabs.indexOf(tab);
      // change active tab
      tab.classList.add("active");
      tab.setAttribute("tabindex", "0");
      tab.setAttribute("aria-selected", "true");
    }

    // change active content
    this.content[tabIndex].classList.add("active");
    this.content[tabIndex].setAttribute("tabindex", "0");
  }

  removeActive(isMobile) {
    let lastActiveTab;

    const lastActiveContent = this.el.querySelector(
      ":scope > [data-content].active"
    );

    if (isMobile) {
      lastActiveTab = this.mobileSelect.querySelector("[aria-selected='true']");
    } else {
      lastActiveTab = this.tabContainer.querySelector(
        ":scope > [data-tab].active"
      );
      lastActiveTab.classList.remove("active");
    }

    lastActiveTab.setAttribute("aria-selected", "false");
    lastActiveTab.setAttribute("tabindex", "-1");
    lastActiveContent.setAttribute("tabindex", "-1");
    lastActiveContent.classList.remove("active");
  }

  beforeRemove() {
    this.tabs.forEach((tab) => {
      tab.removeEventListener("click", this.handleClick);
    });

    if (this.mobileTabsContainer) {
      this.mobileSelect.removeEventListener("change", this.handleMobileClick);
    }
  }
}

export default Tabs;
